import React, { useEffect } from "react";
import ReactGA from "react-ga4";
import classes from "./vtdashboard.module.css";
import { useIndentTracking } from "../../hooks/useIndentTracking";
import VehicleAllocationPanel from "../../../MasterDashboard/panels/VehicleAllocationPanel";
import useViewOnlyAccess from "../../../../hooks/useViewOnlyAccess";

const Vtdashboard = () => {
  const { trackIndentEvent } = useIndentTracking();
  const { isRestricted, handleRestrictedClick } = useViewOnlyAccess("indent", "lorri_indent_tracking", true);

  useEffect(() => {
    document.title = "LoRRI Indent - Indent Tracking Dashboard";
    ReactGA.send("LoRRI Indent - Indent Tracking Dashboard");
    trackIndentEvent(
      "indent request dashboard",
      "user has visited indent tracking dashboard",
    );
  }, []);

  return (
    <div className={`${classes["newcontainer"]}`}>
      <div className={classes["vehicleAllocationEmbed"]}>
        <VehicleAllocationPanel viewOnly={isRestricted} onRestrictedClick={() => handleRestrictedClick()} />
      </div>
    </div>
  );
};

export default Vtdashboard;
